var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54688 12.9717C9.79053 12.9717 11.6094 11.1528 11.6094 8.90918C11.6094 6.66552 9.79053 4.84668 7.54688 4.84668C5.30322 4.84668 3.48438 6.66552 3.48438 8.90918C3.48438 11.1528 5.30322 12.9717 7.54688 12.9717Z",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 4.99512C13.1716 4.89772 13.542 4.84781 13.9141 4.84668C14.9915 4.84668 16.0248 5.27469 16.7867 6.03656C17.5486 6.79842 17.9766 7.83174 17.9766 8.90918C17.9766 9.98662 17.5486 11.0199 16.7867 11.7818C16.0248 12.5437 14.9915 12.9717 13.9141 12.9717",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92188 15.8938C2.55621 14.9912 3.39847 14.2544 4.37751 13.7458C5.35655 13.2372 6.44361 12.9717 7.54688 12.9717C8.65014 12.9717 9.73721 13.2372 10.7162 13.7458C11.6953 14.2544 12.5375 14.9912 13.1719 15.8938",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9141 12.9717C15.0174 12.971 16.1047 13.2362 17.0838 13.7448C18.063 14.2534 18.9052 14.9905 19.5391 15.8936",
    stroke: "#B9B0BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.7bb9c3a7d32ac2f5b769e91be83330e7.svg";
export { ForwardRef as ReactComponent };